const ExcelJS = require('exceljs');

export const sheets = {
    /**
     * @description: Here we will define how to process the data from the front-end into csv or xlsx datasheets
     * @param {Array} items - The data to be processed
     * @param {String} type - The type of the datasheet to be generated
     * @returns {Object} - The datasheet object
     */

    /*
    convertToCSV(arr, headers) {
      // Extract headers:
      const csvHeaders = headers.map(header => header.text).join(',');

      // Map the rows:
      const rows = arr.map(obj =>
        headers.map(header => {
          const keys = header.value.split('.');
          let value = obj;
          keys.forEach(key => {
            value = value[key] || '';
          });
          return `"${value.toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      // Combine headers and rows:
      return [csvHeaders, ...rows].join('\n');
    },

    downloadCSV(arr, headers, filename = 'data.csv') {
      const csvData = this.convertToCSV(arr, headers);
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    */
    generateHeaders: items => {
        return items.length > 0
            ? Object.keys(items[0]).map(key => ({ header: key, key }))
            : [];
    },

    generateData: (items, type, headers) => {
        let processData = (item, header) => {
            const getValue = (item, keys) =>
                keys.split('.').reduce((acc, key) => acc[key] || '', item);

            let value = getValue(item, header.value);

            if (['comments', 'description'].includes(header.value)) {
                value = `"${value
                    .toString()
                    .replace(/"/g, '""')
                    .replace(/,/g, ' ')
                    .replace(/\n/g, ' ')
                    .replace(/\r/g, ' ')}"`;
            } else if (
                ['unit_cost', 'tax', 'subtotal_cost', 'total_cost'].includes(
                    header.value
                )
            ) {
                value = `$${value}`;
            } else if (header.value === 'custom_tax_rate') {
                value = `${value}%`;
            } else if (header.type === 'boolean') {
                value = value ? 'Yes' : 'No';
            }
            return value;
        };

        let data = items.map(item =>
            headers.map(header => processData(item, header))
        );
        return data;
    },
    columnToLetter: column => {
        let temp,
            letter = '',
            col = column;
        while (col > 0) {
            temp = (col - 1) % 26;
            letter = String.fromCharCode(temp + 65) + letter;
            col = (col - temp - 1) / 26;
        }
        return letter;
    },
    downloadSheet: async (sheet, type, title) => {
        let date = new Date()
            .toISOString()
            .slice(0, 19)
            .replace(/:/g, '-');
        if (type === 'csv') {
            console.log(sheet);
            // Get text property from reportHeaders
            let reportHeaders = sheet.headers.map(h => h.text);
            const csvData = [reportHeaders, ...sheet.data].join('\n');
            console.log("csvData: ", csvData);
            const blob = new Blob([csvData], {
                type: 'text/csv;charset=utf-8;'
            });
            console.log('downloadSheet CSV blob: ', blob);
            const url = URL.createObjectURL(blob);
            console.log('downloadSheet CSV url: ', url);

            const link = document.createElement('a');
            link.href = url;
            //Add YYYY-MM-DD-HH-MM-SS to the file name
            link.download = `${title}_${date}.csv`;
            link.style.visibility = 'hidden';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else if (type === 'xlsx') {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Report');

            // Set the columns using the 'text' property from the headers
            worksheet.columns = sheet.headers.map(header => ({
                header: header.text, // Use the 'text' property for the header
                key: header.value, // Use the 'value' property for the key
                width: 20
            }));

            // Add data rows to the worksheet
            sheet.data.forEach(item => {
                let rowData = {};
                sheet.headers.forEach(header => {
                    // Map each header's value property to the corresponding item value
                    rowData[header.value] = item[header.value];
                });
                worksheet.addRow(rowData);
            });

            const lastRow = worksheet.lastRow.number;
            const lastCol = worksheet.columns.length;
            const lastColLetter = sheets.columnToLetter(lastCol);

            worksheet.addTable({
                name: 'MainTable',
                ref: `A1:${lastColLetter}${lastRow}`,
                headerRow: true,
                totalsRow: false,
                style: {
                    theme: 'TableStyleMedium2',
                    showRowStripes: true
                },
                columns: sheet.headers.map(header => ({
                    name: header.text,
                    filterButton: true
                })),
                rows: [] // Since rows are already added, this can be empty
            });

            // Save the workbook to a buffer
            try {
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${title}_${date}.xlsx`;
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error writing Excel file:', error);
            }
        }
    },

    generateSheet: (items, type, originHeaders, title = 'report') => {
        //If no headers are provided, generate them
        let headers = originHeaders || sheets.generateHeaders(items);
        const data = sheets.generateData(items, type, headers);

        return sheets.downloadSheet({ headers, data }, type, title);
    }
};
